import { render } from "./SvgIcon.vue?vue&type=template&id=bafc3cf6&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=bafc3cf6&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/正式_ls/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafc3cf6"]])

export default __exports__